/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargos_NetInputs */

const en_cargos_net = /** @type {(inputs: Cargos_NetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Net`)
};

const es_cargos_net = /** @type {(inputs: Cargos_NetInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neto`)
};

/**
* | output |
* | --- |
* | "Net" |
*
* @param {Cargos_NetInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargos_net = /** @type {((inputs?: Cargos_NetInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargos_NetInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargos_net(inputs)
	return es_cargos_net(inputs)
});